let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cvrnG")).then(() => parcelRequire('hOG2X'));